var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('cell-header');
import { breakpoints, theme } from '@shapeable/theme';
import { CellLabel } from './cell-label';
import { Badge } from './badge';
export var CellHeaderDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    font-size: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    font-size: ", ";\n  "])), theme.FONT_SIZE(12))
});
var CellLabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    line-height: 1.05em;\n    font-size: 1em; \n  "], ["\n    line-height: 1.05em;\n    font-size: 1em; \n  "])))
});
var BadgeStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme.UNIT(3))
});
var LabelAndBadgeStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.header(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  LabelAndBadge: styled.div.attrs(cls.attr('label-and-badge'))(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LabelAndBadgeStyles),
  CellLabel: styled(CellLabel)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), CellLabelStyles),
  Badge: styled(Badge)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles)
};
export var CellHeader = function (props) {
  var className = props.className,
    children = props.children,
    badge = props.badge,
    badgeProps = __rest(props, ["className", "children", "badge"]);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.LabelAndBadge, null, React.createElement(My.CellLabel, null, children), badge && React.createElement(My.Badge, __assign({}, badgeProps), badge)));
};
CellHeader.cls = cls;
CellHeader.defaultProps = CellHeaderDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;